import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import Core from '@/libs/src/core.js';

import dataV from '@jiaminghi/data-view';
import ElementUI from 'element-ui';
import '@/assets/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';
import './utils/style.scss';
import Contextmenu from "vue-contextmenujs";


Vue.use(Contextmenu);
// 
import '@/libs/src/style/common.scss';
import '@/libs/src/style/iconfont.css';
import '@/libs/src/style/iconfont2.css';
import '@/libs/src/style/style.css';
import '@/libs/src/window/ventus.css';

import { iframeConnect } from '@/packages/plugs/iframeConnect';

// 插件安装
Core.plugInstall(iframeConnect);

// register providers
const Application = Core.getProvider('Application');

import('./store/index');
// 安装子应用
import Install from './install-app';
Install(Application);

// 打开地址加密的应用,如果有新窗口的应用时可调用
Application.decryptApp();

Vue.use(ElementUI).use(Core).use(dataV);


Vue.prototype.axios = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

